import React from "react";

const GreyOutText = (props) => <div className="grey">{props.children}</div>;

export default GreyOutText;
